import {
	CustomersScreen,
	CustomersSkeleton,
	customersQuery,
} from "@commerce/customers/CustomersScreen";
import { customersSearchSchema } from "@commerce/customers/meta";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/customers/",
)({
	validateSearch: customersSearchSchema,
	shouldReload: false,
	loader: async ({ context, location }) => {
		const organizationId = context.organization.id;
		const search = customersSearchSchema.parse(location.search);
		const queryClient = getServerQueryClient();
		// A failed prefetch is not the page failing: the screen's own query retries it.
		await queryClient
			.ensureInfiniteQueryData(customersQuery(organizationId, search))
			.catch(() => null);
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	// Shown inside the Shell while the loader runs on a client navigation.
	pendingComponent: CustomersSkeleton,
	head: () => ({ meta: [{ title: `Customers - ${config.appName}` }] }),
	component: CustomersPage,
});

function CustomersPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={<CustomersSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<CustomersScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
